function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { Container } from './elements';
import flags from './data';
var bool = PropTypes.bool,
    string = PropTypes.string;
/**
 * A Flag displays a country flag from the list in `data.js`. It is drawed with a svg so added data
 * should be kept as light as possible.
 *
 * @return {jsx}
 */

var Flag = /*#__PURE__*/function (_PureComponent) {
  _inherits(Flag, _PureComponent);

  var _super = _createSuper(Flag);

  function Flag() {
    var _this;

    _classCallCheck(this, Flag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "groupRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      groupWidth: null,
      groupHeight: null,
      groupX: null,
      groupY: null
    });

    return _this;
  }

  _createClass(Flag, [{
    key: "componentDidMount",
    value:
    /**
     * Updates the size of the rectangle that hides flag corners when rounded option is enabled
     *
     */
    function componentDidMount() {
      var rounded = this.props.rounded;

      if (rounded) {
        var _this$groupRef$curren = this.groupRef.current.getBBox(),
            x = _this$groupRef$curren.x,
            y = _this$groupRef$curren.y,
            height = _this$groupRef$curren.height,
            width = _this$groupRef$curren.width;

        this.setState({
          groupX: x,
          groupY: y,
          groupHeight: height,
          groupWidth: width
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          rounded = _this$props.rounded,
          size = _this$props.size,
          rest = _objectWithoutProperties(_this$props, ["name", "rounded", "size"]);

      var _this$state = this.state,
          groupX = _this$state.groupX,
          groupY = _this$state.groupY,
          groupHeight = _this$state.groupHeight,
          groupWidth = _this$state.groupWidth;
      return /*#__PURE__*/React.createElement(Container, rest, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: 'block'
        },
        width: size,
        height: size,
        viewBox: "0 0 512 512",
        "data-testid": "flagSvg"
      }, /*#__PURE__*/React.createElement("clipPath", {
        id: "rounded-corners"
      }, /*#__PURE__*/React.createElement("rect", {
        rx: "90",
        ry: "90",
        x: groupX,
        y: groupY,
        width: groupWidth,
        height: groupHeight
      })), /*#__PURE__*/React.createElement("g", {
        ref: this.groupRef,
        fill: "none",
        fillRule: "evenodd",
        clipPath: rounded ? 'url(#rounded-corners)' : undefined
      }, flags[name]())));
    }
  }]);

  return Flag;
}(PureComponent);
/**
 * PropTypes Validation.
 */


Flag.propTypes = {
  /**
   * Name of the country flag. Available countries are listed in the data file
   */
  name: string.isRequired,

  /**
   * Size of the flag
   */
  size: string,

  /**
   * Displays the flag with rounded corners or not
   */
  rounded: bool
};
/**
 * Default props.
 */

Flag.defaultProps = {
  size: '20',
  rounded: false
};
export default Flag;